/*
 * Copyright (c) CIRROM 2021.
 */

import React from "react";
import Skeleton from "@mui/material/Skeleton";

import Box from "@mui/material/Box";

import classes from "./NewCRMPanel.module.css";

import { GridLegacy } from "@mui/material";

function SkeletonTicketPanel() {
  return (
    <GridLegacy item xs={15} sm={7} md={4} lg={3} xl={3}>
      <Box className={classes.crmPanelTicketBox}>
        <div className={classes.crmPanelTicketBoxHeader}>
          <Skeleton width={"150px"} height={"30px"} />
        </div>
        <div
          className={classes.crmPanelTicketBoxTrend}
          style={{
            margin: "40px 0px 30px 0px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Skeleton width={"90px"} height={"60px"} />
        </div>
        <div className={classes.crmPanelMoreInfo}>
          <Skeleton width={"50px"} height={"30px"} />
        </div>
      </Box>
    </GridLegacy>
  );
}

export function SkeletonCRMPanel() {
  return (
    <div>
      <Skeleton width={"350px"} height={"50px"} />
      <GridLegacy container spacing={2} rowSpacing={1} columns={15}>
        <SkeletonTicketPanel />
        <SkeletonTicketPanel />
        <SkeletonTicketPanel />
        <SkeletonTicketPanel />
        <SkeletonTicketPanel />
        <GridLegacy item xs={15} sm={15} md={12} lg={12} xl={12}>
          <GridLegacy container spacing={2} rowSpacing={1}>
            <GridLegacy item xs={15} sm={15} md={6} lg={6} xl={6}>
              <div
                className={classes.crmHealthScore}
                style={{ height: "300px" }}
              >
                <Skeleton width={"275px"} height={"50px"} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "80%",
                  }}
                >
                  <Skeleton width={"90%"} height={"100%"} />
                </div>
              </div>
            </GridLegacy>
            <GridLegacy item xs={15} sm={15} md={6} lg={6} xl={6}>
              <div className={classes.allChangesGraph}>
                <Skeleton width={"275px"} height={"50px"} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "80%",
                  }}
                >
                  <Skeleton width={"90%"} height={"100%"} />
                </div>
              </div>
            </GridLegacy>
            <GridLegacy item xs={15} sm={15} md={6.5} lg={7.5} xl={7.5}>
              <div className={classes.contactLocationMap}>
                <Skeleton width={"275px"} height={"50px"} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "80%",
                  }}
                >
                  <Skeleton width={"90%"} height={"100%"} />
                </div>
              </div>
            </GridLegacy>
            <GridLegacy item xs={15} sm={15} md={5.5} lg={4.5} xl={4.5}>
              <div className={classes.autoChangesGraph}>
                <Skeleton width={"275px"} height={"50px"} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    height: "80%",
                  }}
                >
                  <Skeleton width={"90%"} height={"100%"} />
                </div>
              </div>
            </GridLegacy>
          </GridLegacy>
        </GridLegacy>
        <GridLegacy item xs={15} sm={15} md={3} lg={3} xl={3}>
          <GridLegacy container spacing={2} rowSpacing={1} height={"100%"}>
            <GridLegacy
              item
              xs={15}
              sm={15}
              md={15}
              lg={15}
              xl={15}
              height={"100%"}
            >
              <div className={classes.crmPanelCRMOverviewArea}>
                <Skeleton variant={"text"} />
                <Skeleton variant={"text"} />
                <Skeleton variant={"text"} />
                <Skeleton variant={"text"} />
                <Skeleton variant={"text"} />
              </div>
            </GridLegacy>
          </GridLegacy>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}
